(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const R = window.nvRoutes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', cartPage: '/cart' };
  const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });

  let tt;
  const toast = (msg) => { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 2400); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-copy]');
    if (!b) return;
    const v = b.dataset.copy;
    navigator.clipboard.writeText(v).then(() => toast('Adresse copiée'), () => toast(v));
  });

  const tH = $('[data-t="h"]');
  if (tH) {
    const tM = $('[data-t="m"]'), tS = $('[data-t="s"]'), p = (n) => String(n).padStart(2, '0');
    const tick = () => { const now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0); const s = Math.max(0, Math.floor((end - now) / 1000)); tH.textContent = p(Math.floor(s / 3600)); tM.textContent = p(Math.floor(s % 3600 / 60)); tS.textContent = p(s % 60); };
    tick(); setInterval(tick, 1000);
  }

  const menuBtn = $('#menuBtn'), mobileNav = $('#mobileNav');
  if (menuBtn && mobileNav) menuBtn.addEventListener('click', () => { const open = mobileNav.hidden; mobileNav.hidden = !open; menuBtn.setAttribute('aria-expanded', String(open)); });

  const addBiz = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() % 6) n--; } return r; };
  const fmt = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
  $$('[data-date]').forEach((el) => {
    const [a, b] = el.dataset.date.split('-').map(Number), today = new Date();
    el.textContent = b ? fmt(addBiz(today, a)) + ' – ' + fmt(addBiz(today, b)) : fmt(a ? addBiz(today, a) : today);
  });

  const drawer = $('#drawer'), scrim = $('#scrim'), body = $('#cartBody'), foot = $('#cartFoot');
  const productData = (() => { const j = $('#nvProductJson'); try { return j ? JSON.parse(j.textContent) : null; } catch (e) { return null; } })();
  const prodSec = $('#nvProduct');
  const optIndex = (name) => productData ? productData.options.findIndex((o) => (o.name || o).toLowerCase() === String(name || '').toLowerCase()) : -1;
  const colorIdx = prodSec ? optIndex(prodSec.dataset.colorOption) : -1;
  const offerIdx = prodSec ? optIndex(prodSec.dataset.offerOption) : -1;
  const findVariant = (color, offer) => productData && productData.variants.find((v) => (colorIdx < 0 || v.options[colorIdx] === color) && (offerIdx < 0 || v.options[offerIdx] === offer));

  const setCount = (n) => { const c = $('#cartCount'); if (c) c.textContent = n; };
  const openCart = () => { if (!drawer) return; drawer.classList.add('open'); scrim.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); const c = $('#closeCart'); if (c) c.focus(); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('open'); scrim.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  async function renderCart() {
    if (!body) return;
    let cart;
    try { cart = await (await fetch(R.cart, { headers: { Accept: 'application/json' } })).json(); } catch (e) { body.innerHTML = '<p class="empty">Impossible de charger le panier. Rechargez la page.</p>'; return; }
    setCount(cart.item_count);
    if (!cart.items.length) { body.innerHTML = '<p class="empty">Votre panier est vide.</p>'; foot.hidden = true; return; }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it) => `
      <div class="line-item">
        <div class="li-img" style="background-image:url('${it.image ? esc(it.image) : ''}')"></div>
        <div><div class="li-name">${esc(it.product_title)}</div>${it.variant_title ? `<div class="li-var">${esc(it.variant_title)}${it.quantity > 1 ? ' · ×' + it.quantity : ''}</div>` : ''}<button class="li-remove" data-key="${esc(it.key)}" type="button">Retirer</button></div>
        <div class="li-price">${money(it.final_line_price)}${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}</div>
      </div>`).join('');
    let compare = 0;
    cart.items.forEach((it) => {
      const v = productData && productData.variants.find((x) => x.id === it.variant_id);
      compare += (v && v.compare_at_price ? v.compare_at_price : it.original_price) * it.quantity;
    });
    const save = Math.max(0, compare - cart.total_price);
    $('#cartSaveRow').hidden = !save; $('#cartSave').textContent = money(save);
    $('#cartTotal').textContent = money(cart.total_price);
    if (productData && offerIdx > -1 && cart.items.length === 1) {
      const it = cart.items[0], v = productData.variants.find((x) => x.id === it.variant_id);
      const offers = productData.options[offerIdx].values || [...new Set(productData.variants.map((x) => x.options[offerIdx]))];
      if (v && offers.length > 1 && v.options[offerIdx] === offers[0]) {
        const up = findVariant(colorIdx > -1 ? v.options[colorIdx] : null, offers[offers.length - 1]);
        if (up && up.available) {
          body.insertAdjacentHTML('beforeend', `<div class="upsell"><div><b>Passez à « ${esc(offers[offers.length - 1])} » pour +${money(up.price - v.price)}</b>Plus de pocheurs et les cadeaux offerts.</div><button type="button" id="upsellBtn">J'en profite</button></div>`);
          $('#upsellBtn').addEventListener('click', async () => {
            await fetch(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
            await fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: up.id, quantity: 1 }] }) });
            toast('Offre mise à jour'); renderCart();
          });
        }
      }
    }
    $$('.li-remove', body).forEach((b) => b.addEventListener('click', async () => {
      await fetch(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) });
      renderCart();
    }));
  }
  const cartBtn = $('#cartBtn');
  if (cartBtn && drawer) cartBtn.addEventListener('click', (e) => { e.preventDefault(); renderCart(); openCart(); });
  if (scrim) scrim.addEventListener('click', closeCart);
  const cc = $('#closeCart'); if (cc) cc.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  if (prodSec && productData) {
    const slides = $$('#stage .slide'), thumbs = $$('.thumb'), row = $('#thumbRow');
    let idx = 0;
    const show = (i) => {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, j) => s.classList.toggle('on', j === idx));
      thumbs.forEach((t, j) => t.setAttribute('aria-current', j === idx ? 'true' : 'false'));
      const t = thumbs[idx];
      if (row && t) row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    const pv = $('#thPrev'), nx = $('#thNext');
    if (pv) pv.addEventListener('click', () => show(idx - 1));
    if (nx) nx.addEventListener('click', () => show(idx + 1));
    const stage = $('#stage'); let x0 = null;
    if (stage) {
      stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
      stage.addEventListener('pointerup', (e) => { if (x0 !== null && Math.abs(e.clientX - x0) > 40) show(idx + (e.clientX < x0 ? 1 : -1)); x0 = null; });
    }

    const colorRadios = $$('input[name="nv-color"]'), offerRadios = $$('input[name="nv-offer"]');
    const getColor = () => { const r = colorRadios.find((x) => x.checked); return r ? r.value : null; };
    const getOffer = () => { const r = offerRadios.find((x) => x.checked); return r ? r.value : null; };
    const params = new URLSearchParams(location.search);
    const wanted = params.get('coloris');
    if (wanted) { const r = colorRadios.find((x) => x.value.toLowerCase() === wanted.toLowerCase()); if (r) r.checked = true; }

    const idInput = $('#nvVariantId'), addBtn = $('#addBtn'), addLabel = $('#addLabel');
    const sync = (jump) => {
      const color = getColor(), offer = getOffer();
      const v = findVariant(color, offer) || productData.variants[0];
      idInput.value = v.id;
      const cmp = v.compare_at_price && v.compare_at_price > v.price;
      $('#price').textContent = money(v.price);
      const c = $('#compare'), sb = $('#saveBadge');
      c.hidden = !cmp; sb.hidden = !cmp;
      if (cmp) { c.textContent = money(v.compare_at_price); sb.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + ' %'; }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Ajouter au panier · ' + money(v.price) : 'Épuisé';
      const sp = $('#sbPrice'), sc = $('#sbCompare');
      if (sp) sp.textContent = money(v.price);
      if (sc) sc.textContent = cmp ? money(v.compare_at_price) : '';
      const cn = $('#colorName'); if (cn && color) cn.textContent = color;
      offerRadios.forEach((r) => {
        const ov = findVariant(color, r.value), lab = r.closest('.bundle');
        if (!ov || !lab) return;
        lab.querySelector('[data-offer-price]').textContent = money(ov.price);
        lab.querySelector('[data-offer-compare]').textContent = ov.compare_at_price > ov.price ? money(ov.compare_at_price) : '';
      });
      const sel = offerRadios.find((x) => x.checked), gifts = $('#gifts');
      if (gifts) {
        const on = !!(sel && sel.dataset.gifts === '1');
        gifts.dataset.on = String(on);
        $$('.gift-status', gifts).forEach((s) => { s.textContent = on ? s.dataset.on : s.dataset.off; });
      }
      if (jump && color) { const k = slides.findIndex((s) => (s.dataset.color || '').toLowerCase() === color.toLowerCase()); if (k > -1) show(k); }
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    };
    colorRadios.forEach((r) => r.addEventListener('change', () => sync(true)));
    offerRadios.forEach((r) => r.addEventListener('change', () => sync(false)));
    sync(!!wanted);

    const form = $('#nvAddForm');
    const add = async (e) => {
      if (e) e.preventDefault();
      addBtn.disabled = true;
      try {
        const res = await fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) });
        if (!res.ok) { const err = await res.json().catch(() => ({})); toast(err.description || "Ce produit n'a pas pu être ajouté. Réessayez."); return; }
        await renderCart(); openCart();
      } catch (err) { form.submit(); }
      finally { addBtn.disabled = false; sync(false); }
    };
    if (form) form.addEventListener('submit', add);
    const sbAdd = $('#sbAdd'); if (sbAdd) sbAdd.addEventListener('click', () => add());

    const sb = $('#stickyBuy'), main = $('#mainCta');
    if (sb && main && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => {
      const on = !en.isIntersecting && en.boundingClientRect.top < 0;
      sb.classList.toggle('show', on); sb.setAttribute('aria-hidden', String(!on)); if (sbAdd) sbAdd.tabIndex = on ? 0 : -1;
    }).observe(main);
  }
  $$('[data-scroll-buy]').forEach((a) => a.addEventListener('click', (e) => { const t = $('#nvProduct'); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }));

  $$('.rev-nav').forEach((nav) => {
    const track = nav.closest('section').querySelector('.rev-track');
    if (!track) return;
    $$('[data-rev]', nav).forEach((b) => b.addEventListener('click', () => { const card = track.querySelector('.review'); track.scrollBy({ left: Number(b.dataset.rev) * ((card ? card.offsetWidth : 300) + 18), behavior: 'smooth' }); }));
  });
  $$('.review .more').forEach((b) => b.addEventListener('click', () => { const r = b.closest('.review'); r.classList.toggle('open'); b.textContent = r.classList.contains('open') ? 'Voir moins' : 'Voir plus'; }));

  const setMsg = (el, text, ok) => { el.textContent = text; el.className = 'track-msg ' + (ok ? 'ok' : 'err'); el.hidden = false; };
  const tOrder = $('#trackOrder');
  if (tOrder) tOrder.addEventListener('submit', (e) => {
    e.preventDefault();
    const o = $('#tOrder'), c = $('#tContact'), m = $('#tOrderMsg');
    const order = o.value.trim().replace(/^#/, ''), contact = c.value.trim();
    const okOrder = /^\d{3,}$/.test(order);
    const okContact = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact) || contact.replace(/\D/g, '').length >= 9;
    o.setAttribute('aria-invalid', String(!okOrder)); c.setAttribute('aria-invalid', String(!okContact));
    if (!okOrder) return setMsg(m, 'Saisissez le numéro de commande indiqué dans votre e-mail de confirmation, par exemple #1024.');
    if (!okContact) return setMsg(m, "Saisissez l'adresse e-mail ou le numéro de téléphone utilisé lors de la commande.");
    setMsg(m, "Le lien « Voir ma commande » de votre e-mail de confirmation affiche le suivi en temps réel. Vous ne le trouvez pas ? Écrivez-nous avec le numéro #" + order + ', nous vous répondons sous 24 h.', true);
  });
  const tNum = $('#trackNum');
  if (tNum) tNum.addEventListener('submit', (e) => {
    e.preventDefault();
    const n = $('#tNum'), m = $('#tNumMsg'), v = n.value.trim().replace(/\s/g, '');
    const ok = /^[A-Za-z0-9]{8,30}$/.test(v);
    n.setAttribute('aria-invalid', String(!ok));
    if (!ok) return setMsg(m, 'Le numéro de suivi contient entre 8 et 30 lettres et chiffres, sans espace.');
    const url = (tNum.dataset.url || 'https://t.17track.net/fr#nums={num}').replace('{num}', encodeURIComponent(v.toUpperCase()));
    setMsg(m, 'Ouverture du suivi du colis ' + v.toUpperCase() + '…', true);
    window.open(url, '_blank', 'noopener');
  });
})();
